import { render, staticRenderFns } from "./RefundInfo.vue?vue&type=template&id=0084aeb0&scoped=true"
import script from "./RefundInfo.vue?vue&type=script&lang=js"
export * from "./RefundInfo.vue?vue&type=script&lang=js"
import style0 from "./RefundInfo.vue?vue&type=style&index=0&id=0084aeb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084aeb0",
  null
  
)

export default component.exports